module.exports = __webpack_public_path__ + "static/media/WBN_PREMIUM.234f8b3f.svg";